import { History } from "./History";
import { List } from "./List";

export const Transaction = {
  History,
  List,
};
